type Radius = 'none' | 'small' | 'medium' | 'large' | 'full';

interface ThemeConfig {
  radius: Radius;
  badgeRadius: Radius;
  scrollRadius: Radius;
}

export const THEME: ThemeConfig = {
  radius: 'full',
  badgeRadius: 'full',
  scrollRadius: 'full'
};
